/* -------------------------------------------------------------------------- */
/*                                Radio styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-radio.variables';

:host {
  @apply inline-block;
}

.bq-radio {
  @apply box-border inline-flex cursor-pointer items-center justify-center gap-2 transition-[background-color] duration-300;
  @apply rounded-s p-b-xs p-i-xs;

  &.is-disabled {
    @apply cursor-not-allowed opacity-60;

    &.is-checked .bq-radio__circle {
      @apply border-icon-brand;
    }

    &.is-checked .bq-radio__checked {
      @apply bg-ui-brand;
    }
  }

  &.has-background:not(.is-disabled):hover {
    @apply bg-hover-ui-primary;
  }

  &.is-checked:not(.is-disabled) {
    .bq-radio__circle {
      @apply border-icon-brand;
    }

    .bq-radio__checked {
      @apply bg-ui-brand;
    }
  }

  &:not(.is-disabled):hover .bq-radio__circle {
    @apply border-hover-icon-brand;
  }

  &.is-checked:not(.is-disabled):hover {
    .bq-radio__checked,
    .bq-radio__circle {
      @apply border-hover-icon-brand;
    }
  }
}

.bq-radio__input {
  @apply sr-only;

  &:focus-visible {
    ~ .bq-radio__circle {
      @apply focus;
    }
  }
}

.bq-radio__control {
  @apply box-border flex items-center justify-center rounded-full bs-[--bq-radio--size] is-[--bq-radio--size] p-b-[2px] p-i-[2px];
}

.bq-radio__circle {
  @apply relative box-border flex items-center justify-center rounded-full border-[length:--bq-radio--border-width] border-solid border-hover-icon-primary bs-full is-full p-b-[3px] p-i-[3px];
}

.bq-radio__checked {
  @apply rounded-full bs-full is-full;
}

.bq-radio__label {
  @apply font-medium leading-regular text-primary;
}

.bq-radio__circle,
.bq-radio__checked,
.bq-radio__label {
  @apply transition-[color,background-color,border-color,box-shadow] duration-300;
}
